import React, { useEffect } from "react";
import Footer from "../common/Footer/Footer";
import Header from "../common/Header/Header";
import Banner from "../components/Banner";
import NewsAndBlog from "../components/NewsAndBlogs";
import HowDoesItWork from "../components/HowDoesItWork/HowDoesItWork";
import SpecializationCategories from "../components/SpecializationCategories/SpecializationCategories";
import OurExpertStaff from "../components/ourExpertStaff/OurExpertStaff";
import TestimonialsSlider from "../components/TestimonialSlider";
import MultilingualPlatform from "../components/MultilingualPlatform/MultilingualPlatform";
import ProfessionalTherapistPage from "../components/ProfessionalTherapists/ProfessionalTherapistPage";
import YoutubeSection from "../components/YoutubeSection/YoutubeSection";
import LiveStreamBanner from "../components/LiveStreamBanner/LiveStreamBanner";
import { MotionFadeDown, MotionFadeLeft, MotionFadeUp, MotionZoomIn } from "../wrapper/MotionsWrapper";
import { useLocation } from "react-router-dom";
import SEO from "../components/SEO/SEO";
import TherapiesSection from "../components/TherapiesSection/TherapiesSection";
import { YouTubeProvider } from "../contexts/YouTubeContext";


const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const scrollToSection = () => {
      const target = document.getElementById("how-does-it-work");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    if (
      location.pathname === "/how-does-it-work" ||
      location.hash === "#how-does-it-work"
    ) {
      setTimeout(scrollToSection, 100);
    }
  }, [location]);

  return (
    <YouTubeProvider>
    <div>
      <LiveStreamBanner />
      <SEO
        title="Online Therapy Platform"
        description="Find your therapist and start your online therapy journey. Professional, confidential and accessible mental health support."
        canonical="https://mindtherapycounselling.com/"
      />
      <Header />

      <MotionFadeDown>
        <Banner />
      </MotionFadeDown>

      <MultilingualPlatform />

      <MotionZoomIn delay={0.2} duration={0.8}>
        <HowDoesItWork />
      </MotionZoomIn>

      <MotionFadeLeft>
        <SpecializationCategories />
      </MotionFadeLeft>

      <TherapiesSection />

      <MotionZoomIn >
        <ProfessionalTherapistPage />
      </MotionZoomIn>

      <MotionFadeUp>
        <OurExpertStaff />
      </MotionFadeUp>

      <MotionZoomIn>
        <TestimonialsSlider />
      </MotionZoomIn>
      <MotionFadeUp>
        <YoutubeSection />
      </MotionFadeUp>
      <NewsAndBlog />
      <Footer />
    </div>
    </YouTubeProvider>
  );
};

export default HomePage;
